export interface NestableItem {
    id?: string;
    children?: NestableItem[];
    [x: string]: any;
}

export function findNested(id, items: NestableItem[]): NestableItem {
    for (const item of items) {
        if (item.id === id) {
            return item;
        }

        if (item.children) {
            const m = findNested(id, item.children);

            if (m) {
                return m;
            }
        }
    }
}
